// // import React, { useState, useEffect } from 'react';
// // import Layout from '../components/layout';
// // import { Bar } from 'react-chartjs-2';
// // import {
// //     Chart as ChartJS,
// //     CategoryScale,
// //     LinearScale,
// //     BarElement,
// //     Title,
// //     Tooltip,
// //     Legend,
// // } from 'chart.js';
// // import { jsPDF } from 'jspdf';
// // import axios from 'axios';
// // import { MdOutlineMonetizationOn } from 'react-icons/md';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // // Mock static data
// // const staticBillingData = [
// //     {
// //         startDate: '2025-05-01',
// //         endDate: '2025-05-31',
// //         conversations: 2156,
// //         costPerConversation: 4,
// //         totalCost: 2156 * 4,
// //     },
// //     {
// //         startDate: '2025-04-01',
// //         endDate: '2025-04-30',
// //         conversations: 2000,
// //         costPerConversation: 4,
// //         totalCost: 2000 * 4,
// //     },
// //     {
// //         startDate: '2025-03-01',
// //         endDate: '2025-03-31',
// //         conversations: 1800,
// //         costPerConversation: 4,
// //         totalCost: 1800 * 4,
// //     },
// // ];

// // function Billing() {
// //     const [startDate, setStartDate] = useState('');
// //     const [endDate, setEndDate] = useState('');
// //     const [billingData, setBillingData] = useState(staticBillingData[0]);
// //     const [history, setHistory] = useState(staticBillingData);
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [loading, setLoading] = useState(false);
// //     const itemsPerPage = 5;

// //     // Mock API fetch (replace with your endpoint)
// //     const fetchBillingData = async (start, end) => {
// //         setLoading(true);
// //         try {
// //             // Replace with your API endpoint
// //             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
// //                 startDate: start,
// //                 endDate: end,
// //             });
// //             // For now, use static data
// //             setBillingData({
// //                 startDate: start || '2025-05-01',
// //                 endDate: end || '2025-05-31',
// //                 conversations: 2156,
// //                 costPerConversation: 4,
// //                 totalCost: 2156 * 4,
// //             });
// //             setHistory(staticBillingData); // Update history with static data
// //         } catch (err) {
// //             console.error('API error:', err);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchBillingData(startDate, endDate);
// //     }, []);

// //     const handleDateChange = () => {
// //         if (startDate && endDate) {
// //             fetchBillingData(startDate, endDate);
// //         }
// //     };

// //     // Download as CSV
// //     const downloadCSV = () => {
// //         const csvContent = [
// //             ['Start Date', 'End Date', 'Conversations', 'Cost per Conversation (₹)', 'Total Cost (₹)'],
// //             [
// //                 billingData.startDate,
// //                 billingData.endDate,
// //                 billingData.conversations,
// //                 billingData.costPerConversation,
// //                 billingData.totalCost,
// //             ],
// //         ]
// //             .map(row => row.join(','))
// //             .join('\n');
// //         const blob = new Blob([csvContent], { type: 'text/csv' });
// //         const url = window.URL.createObjectURL(blob);
// //         const a = document.createElement('a');
// //         a.href = url;
// //         a.download = `billing_${billingData.startDate}_to_${billingData.endDate}.csv`;
// //         a.click();
// //         window.URL.revokeObjectURL(url);
// //     };

// //     // Download as PDF
// //     const downloadPDF = () => {
// //         const doc = new jsPDF();
// //         doc.setFontSize(18);
// //         doc.text('Billing Summary', 20, 20);
// //         doc.setFontSize(12);
// //         doc.text(`Start Date: ${billingData.startDate}`, 20, 40);
// //         doc.text(`End Date: ${billingData.endDate}`, 20, 50);
// //         doc.text(`Conversations: ${billingData.conversations}`, 20, 60);
// //         doc.text(`Cost per Conversation: ₹${billingData.costPerConversation}`, 20, 70);
// //         doc.text(`Total Cost: ₹${billingData.totalCost}`, 20, 80);
// //         doc.save(`billing_${billingData.startDate}_to_${billingData.endDate}.pdf`);
// //     };

// //     // Pagination for history
// //     const totalPages = Math.ceil(history.length / itemsPerPage);
// //     const paginatedHistory = history.slice(
// //         (currentPage - 1) * itemsPerPage,
// //         currentPage * itemsPerPage
// //     );

// //     // Chart data for billing trends
// //     const billingChartData = {
// //         labels: history.map(item => item.startDate),
// //         datasets: [
// //             {
// //                 label: 'Total Cost (₹)',
// //                 data: history.map(item => item.totalCost),
// //                 backgroundColor: '#3B82F6',
// //             },
// //         ],
// //     };

// //     const chartOptions = {
// //         responsive: true,
// //         maintainAspectRatio: false,
// //         plugins: {
// //             legend: { position: 'top' },
// //             title: { display: true, text: 'Billing Trends Over Time' },
// //         },
// //     };

// //     return (
// //         <Layout>
// //             <div className="min-h-screen p-6">
// //                 {/* Billing Summary Card */}
// //                 <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 mb-6">
// //                     <div className="flex items-center justify-between">
// //                         <div>
// //                             <h2 className="text-xl font-semibold text-gray-800 mb-1">Billing Summary</h2>
// //                             <p className="text-sm text-gray-500">Total cost for selected period</p>
// //                         </div>
// //                         <div className="text-right">
// //                             <p className="text-2xl font-bold text-blue-600">₹{billingData.totalCost.toFixed(2)}</p>
// //                             <p className="text-sm text-gray-500">For {billingData.conversations} conversations</p>
// //                         </div>
// //                     </div>
// //                     <div className="mt-6 flex items-center gap-4">
// //                         <div>
// //                             <label className="block text-sm font-medium text-gray-700">Start Date</label>
// //                             <input
// //                                 type="date"
// //                                 value={startDate}
// //                                 onChange={(e) => setStartDate(e.target.value)}
// //                                 className="border rounded px-3 py-2 text-sm"
// //                             />
// //                         </div>
// //                         <div>
// //                             <label className="block text-sm font-medium text-gray-700">End Date</label>
// //                             <input
// //                                 type="date"
// //                                 value={endDate}
// //                                 onChange={(e) => setEndDate(e.target.value)}
// //                                 className="border rounded px-3 py-2 text-sm"
// //                             />
// //                         </div>
// //                         <button
// //                             onClick={handleDateChange}
// //                             className="bg-blue-600 text-white px-4 py-2 rounded mt-6"
// //                             disabled={loading}
// //                         >
// //                             {loading ? 'Loading...' : 'Update'}
// //                         </button>
// //                     </div>
// //                     <div className="mt-6 flex gap-4">
// //                         <button
// //                             onClick={downloadCSV}
// //                             className="bg-green-600 text-white px-4 py-2 rounded flex items-center gap-2"
// //                         >
// //                             <MdOutlineMonetizationOn /> Download CSV
// //                         </button>
// //                         <button
// //                             onClick={downloadPDF}
// //                             className="bg-red-600 text-white px-4 py-2 rounded flex items-center gap-2"
// //                         >
// //                             <MdOutlineMonetizationOn /> Download PDF
// //                         </button>
// //                     </div>
// //                 </div>

// //                 {/* Billing Trends Chart */}
// //                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
// //                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Billing Trends</h2>
// //                     <div className="h-80">
// //                         <Bar data={billingChartData} options={chartOptions} />
// //                     </div>
// //                 </div>

// //                 {/* Billing History */}
// //                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
// //                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Billing History</h2>
// //                     <div className="overflow-x-auto">
// //                         <table className="min-w-full divide-y divide-gray-200">
// //                             <thead className="bg-gray-50">
// //                                 <tr>
// //                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start Date</th>
// //                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End Date</th>
// //                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conversations</th>
// //                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Cost (₹)</th>
// //                                 </tr>
// //                             </thead>
// //                             <tbody className="bg-white divide-y divide-gray-200">
// //                                 {paginatedHistory.map((item, index) => (
// //                                     <tr key={index}>
// //                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.startDate}</td>
// //                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.endDate}</td>
// //                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.conversations}</td>
// //                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">₹{item.totalCost.toFixed(2)}</td>
// //                                     </tr>
// //                                 ))}
// //                             </tbody>
// //                         </table>
// //                     </div>
// //                     {/* Pagination */}
// //                     <div className="mt-4 flex justify-between items-center">
// //                         <button
// //                             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
// //                             disabled={currentPage === 1}
// //                             className="bg-blue-600 text-white px-4 py-2 rounded disabled:bg-gray-300"
// //                         >
// //                             Previous
// //                         </button>
// //                         <span className="text-sm text-gray-700">
// //                             Page {currentPage} of {totalPages}
// //                         </span>
// //                         <button
// //                             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
// //                             disabled={currentPage === totalPages}
// //                             className="bg-blue-600 text-white px-4 py-2 rounded disabled:bg-gray-300"
// //                         >
// //                             Next
// //                         </button>
// //                     </div>
// //                 </div>
// //             </div>
// //         </Layout>
// //     );
// // }

// // export default Billing;

// // import React, { useState, useEffect } from 'react';
// // import Layout from '../components/layout';
// // import { Bar } from 'react-chartjs-2';
// // import {
// //     Chart as ChartJS,
// //     CategoryScale,
// //     LinearScale,
// //     BarElement,
// //     Title,
// //     Tooltip,
// //     Legend,
// // } from 'chart.js';
// // import axios from 'axios';
// // import { MdOutlineMonetizationOn } from 'react-icons/md';
// // import DownloadButton from '../components/downloadButton';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // // Static data for billing
// // const staticBillingData = [
// //     {
// //         date: '2025-05-13',
// //         conversations: 2156,
// //         costPerConversation: 4,
// //         totalCost: 2156 * 4,
// //     },
// //     {
// //         date: '2025-04-15',
// //         conversations: 2000,
// //         costPerConversation: 4,
// //         totalCost: 2000 * 4,
// //     },
// //     {
// //         date: '2025-03-10',
// //         conversations: 1800,
// //         costPerConversation: 4,
// //         totalCost: 1800 * 4,
// //     },
// // ];

// // function Billing() {
// //     const [startDate, setStartDate] = useState('');
// //     const [endDate, setEndDate] = useState('');
// //     const [billingData, setBillingData] = useState(null);
// //     const [loading, setLoading] = useState(false);

// //     // Mock API fetch (replace with your endpoint)
// //     const fetchBillingData = async (start, end) => {
// //         setLoading(true);
// //         try {
// //             // Replace with your API endpoint
// //             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
// //                 startDate: start,
// //                 endDate: end,
// //             });
// //             // Use static data for now
// //             const isSingleDay = start === end;
// //             const filteredData = staticBillingData.find(item =>
// //                 isSingleDay ? item.date === start :
// //                 (new Date(item.date) >= new Date(start) && new Date(item.date) <= new Date(end))
// //             ) || staticBillingData[0]; // Fallback to first static data if no match
// //             setBillingData({
// //                 startDate: start || filteredData.date,
// //                 endDate: end || filteredData.date,
// //                 conversations: filteredData.conversations,
// //                 costPerConversation: filteredData.costPerConversation,
// //                 totalCost: filteredData.totalCost,
// //             });
// //         } catch (err) {
// //             console.error('API error:', err);
// //             // Fallback to static data on error
// //             setBillingData(staticBillingData[0]);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchBillingData('2025-05-13', '2025-05-13'); // Default to a single day
// //     }, []);

// //     const handleDateChange = () => {
// //         if (startDate && endDate) {
// //             if (new Date(startDate) > new Date(endDate)) {
// //                 alert('Start date cannot be after end date');
// //                 return;
// //             }
// //             fetchBillingData(startDate, endDate);
// //         }
// //     };

// //     // Data for DownloadButton
// //     const downloadData = billingData ? [{
// //         'Start Date': billingData.startDate,
// //         'End Date': billingData.endDate,
// //         'Conversations': billingData.conversations,
// //         'Cost per Conversation (₹)': billingData.costPerConversation,
// //         'Total Cost (₹)': billingData.totalCost,
// //     }] : [];

// //     // Chart data for billing trends
// //     const billingChartData = {
// //         labels: staticBillingData.map(item => item.date),
// //         datasets: [
// //             {
// //                 label: 'Total Cost (₹)',
// //                 data: staticBillingData.map(item => item.totalCost),
// //                 // backgroundColor: '#3B82F6',
// //                 backgroundColor: [
// //                     '#A5B4FC', // Soft Indigo
// //                     '#FBCFE8', // Soft Pink
// //                     '#C7D2FE', // Light Blue
// //                     '#FDE68A', // Soft Yellow
// //                     '#BFDBFE', // Sky Blue
// //                     '#DDD6FE', // Light Purple
// //                     '#BBF7D0', // Mint Green
// //                     '#FCD34D', // Light Amber
// //                     '#FCA5A5', // Soft Red
// //                     '#E0E7FF', // Lavender Blue
// //                     '#FDBA74', // Soft Orange
// //                     '#D1D5DB', // Cool Gray
// //                 ],
// //             },
// //         ],
// //     };

// //     const chartOptions = {
// //         responsive: true,
// //         maintainAspectRatio: false,
// //         plugins: {
// //             legend: { position: 'top' },
// //             title: { display: true, text: 'Billing Trends' },
// //         },
// //     };

// //     return (
// //         <Layout>
// //             <div className="min-h-screen p-6">
// //                 {/* Billing Summary Card */}
// //                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
// //                     <div className="flex items-center justify-between">
// //                         <div>
// //                             <h2 className="text-xl font-semibold  mb-1">Billing Summary</h2>
// //                             <p className="text-sm ">
// //                                 {billingData?.startDate === billingData?.endDate
// //                                     ? `For ${billingData?.startDate}`
// //                                     : `From ${billingData?.startDate} to ${billingData?.endDate}`}
// //                             </p>
// //                         </div>
// //                         <div className="text-right">
// //                             <p className="text-2xl font-bold ">
// //                                 ₹{billingData?.totalCost.toFixed(2) || '0.00'}
// //                             </p>
// //                             <p className="text-sm ">
// //                                 For {billingData?.conversations || 0} conversations
// //                             </p>
// //                         </div>
// //                     </div>
// //                     <div className="mt-6 flex items-center gap-4">
// //                         <div>
// //                             <label className="block text-sm font-medium ">Start Date</label>
// //                             <input
// //                                 type="date"
// //                                 value={startDate}
// //                                 onChange={(e) => setStartDate(e.target.value)}
// //                                 className="border rounded px-3 py-2 text-sm bg-transparent"
// //                             />
// //                         </div>
// //                         <div>
// //                             <label className="block text-sm font-medium">End Date</label>
// //                             <input
// //                                 type="date"
// //                                 value={endDate}
// //                                 onChange={(e) => setEndDate(e.target.value)}
// //                                 className="border rounded px-3 py-2 text-sm bg-transparent"
// //                             />
// //                         </div>
// //                         <button
// //                             onClick={handleDateChange}
// //                             className="hover:bg-indigo-600 text-white px-4 py-2 rounded mt-6 border border-white"
// //                             disabled={loading}
// //                         >
// //                             {loading ? 'Loading...' : 'Update'}
// //                         </button>
// //                     </div>
// //                     <div className="mt-6">
// //                         <DownloadButton
// //                             data={downloadData}
// //                             filename={`billing_${billingData?.startDate}_to_${billingData?.endDate}`}
// //                         />
// //                     </div>
// //                 </div>

// //                 {/* Billing Trends Chart */}
// //                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
// //                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Billing Trends</h2>
// //                     <div className="h-80">
// //                         <Bar data={billingChartData} options={chartOptions} />
// //                     </div>
// //                 </div>
// //             </div>
// //         </Layout>
// //     );
// // }

// // export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import { MdOutlineMonetizationOn } from 'react-icons/md';
// import DownloadButton from '../components/downloadButton';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // Static data for billing (daily data for May 2025, 31 days)
// const staticBillingData = Array.from({ length: 31 }, (_, i) => {
//     const day = String(i + 1).padStart(2, '0');
//     const conversations = 2000 + Math.floor(Math.random() * 500); // Random between 2000-2500
//     return {
//         date: `2025-05-${day}`,
//         conversations,
//         costPerConversation: 4,
//         totalCost: conversations * 4,
//     };
// });

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     // Mock API fetch (replace with your endpoint)
//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             // Replace with your API endpoint
//             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
//                 month: month, // e.g., "2025-05"
//             });
//             // Use static data for now
//             const filteredData = staticBillingData.filter(item => item.date.startsWith(month));
//             const aggregated = filteredData.reduce(
//                 (acc, item) => ({
//                     conversations: acc.conversations + item.conversations,
//                     totalCost: acc.totalCost + item.totalCost,
//                 }),
//                 { conversations: 0, totalCost: 0 }
//             );
//             setBillingData({
//                 month: month || '2025-05',
//                 conversations: aggregated.conversations,
//                 costPerConversation: 4,
//                 totalCost: aggregated.totalCost,
//                 dailyData: filteredData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             // Fallback to static data on error
//             const filteredData = staticBillingData.filter(item => item.date.startsWith('2025-05'));
//             const aggregated = filteredData.reduce(
//                 (acc, item) => ({
//                     conversations: acc.conversations + item.conversations,
//                     totalCost: acc.totalCost + item.totalCost,
//                 }),
//                 { conversations: 0, totalCost: 0 }
//             );
//             setBillingData({
//                 month: '2025-05',
//                 conversations: aggregated.conversations,
//                 costPerConversation: 4,
//                 totalCost: aggregated.totalCost,
//                 dailyData: filteredData,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth); // Default to May 2025
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for DownloadButton
//     const downloadData = billingData ? [{
//         'Month': billingData.month,
//         'Total Conversations': billingData.conversations,
//         'Cost per Conversation (₹)': billingData.costPerConversation,
//         'Total Cost (₹)': billingData.totalCost,
//     }] : [];

//     // Chart data for daily conversation trends
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [], // Extract day (e.g., "01", "02")
//         datasets: [
//             {
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 backgroundColor: [
//                     '#A5B4FC', // Soft Indigo
//                     '#FBCFE8', // Soft Pink
//                     '#C7D2FE', // Light Blue
//                     '#FDE68A', // Soft Yellow
//                     '#BFDBFE', // Sky Blue
//                     '#DDD6FE', // Light Purple
//                     '#BBF7D0', // Mint Green
//                     '#FCD34D', // Light Amber
//                     '#FCA5A5', // Soft Red
//                     '#E0E7FF', // Lavender Blue
//                     '#FDBA74', // Soft Orange
//                     '#D1D5DB', // Cool Gray
//                     '#A5B4FC', // Repeat colors
//                     '#FBCFE8',
//                     '#C7D2FE',
//                     '#FDE68A',
//                     '#BFDBFE',
//                     '#DDD6FE',
//                     '#BBF7D0',
//                     '#FCD34D',
//                     '#FCA5A5',
//                     '#E0E7FF',
//                     '#FDBA74',
//                     '#D1D5DB',
//                     '#A5B4FC',
//                     '#FBCFE8',
//                     '#C7D2FE',
//                     '#FDE68A',
//                     '#BFDBFE',
//                     '#DDD6FE',
//                     '#BBF7D0',
//                 ],
//             },

//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Conversation Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             y: {
//                 title: { display: true, text: 'Conversations' },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 ₹{billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center gap-4">
//                         <div>
//                             <label className="block text-sm font-medium">Select Month</label>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-sm bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-600 text-white px-4 py-2 rounded mt-6 border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6">
//                         <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month}`}
//                         />
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Conversation Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import { MdOutlineMonetizationOn } from 'react-icons/md';
// import DownloadButton from '../components/downloadButton';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// // Static data for billing (daily data for May 2025, 31 days)
// const staticBillingData = Array.from({ length: 31 }, (_, i) => {
//     const day = String(i + 1).padStart(2, '0');
//     const conversations = 2000 + Math.floor(Math.random() * 500); // Random between 2000-2500
//     return {
//         date: `2025-05-${day}`,
//         conversations,
//         costPerConversation: 4,
//         totalCost: conversations * 4,
//     };
// });

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     // Mock API fetch (replace with your endpoint)
//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             // Replace with your API endpoint
//             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
//                 month: month, // e.g., "2025-05"
//             });
//             // Use static data for now
//             const filteredData = staticBillingData.filter(item => item.date.startsWith(month));
//             const aggregated = filteredData.reduce(
//                 (acc, item) => ({
//                     conversations: acc.conversations + item.conversations,
//                     totalCost: acc.totalCost + item.totalCost,
//                 }),
//                 { conversations: 0, totalCost: 0 }
//             );
//             setBillingData({
//                 month: month || '2025-05',
//                 conversations: aggregated.conversations,
//                 costPerConversation: 4,
//                 totalCost: aggregated.totalCost,
//                 dailyData: filteredData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             // Fallback to static data on error
//             const filteredData = staticBillingData.filter(item => item.date.startsWith('2025-05'));
//             const aggregated = filteredData.reduce(
//                 (acc, item) => ({
//                     conversations: acc.conversations + item.conversations,
//                     totalCost: acc.totalCost + item.totalCost,
//                 }),
//                 { conversations: 0, totalCost: 0 }
//             );
//             setBillingData({
//                 month: '2025-05',
//                 conversations: aggregated.conversations,
//                 costPerConversation: 4,
//                 totalCost: aggregated.totalCost,
//                 dailyData: filteredData,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth); // Default to May 2025
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for DownloadButton
//     const downloadData = billingData ? [{
//         'Month': billingData.month,
//         'Total Conversations': billingData.conversations,
//         'Cost per Conversation (₹)': billingData.costPerConversation,
//         'Total Cost (₹)': billingData.totalCost,
//     }] : [];

//     // Chart data for daily billing trends (combo bar and line)
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [], // Extract day (e.g., "01", "02")
//         datasets: [

//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5', // Soft Pink
//                 backgroundColor: '#c99bb5',
//                 // tension: 0.4,
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (₹)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC', // Soft Indigo
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (₹)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations' },
//                 grid: { display: false },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 ₹{billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             {/* <label className="block text-sm font-medium">Select Month</label> */}
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1">
//                         <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month}`}
//                         />
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import { MdOutlineMonetizationOn } from 'react-icons/md';
// import DownloadButton from '../components/downloadButton';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
//                 month: month,
//             }, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const apiData = response.data;
//             const dailyData = apiData.data.map(item => ({
//                 date: item.date,
//                 conversations: item.total_conversations,
//                 costPerConversation: item.cost / item.total_conversations, // Calculate cost per conversation
//                 totalCost: item.cost,
//             }));

//             setBillingData({
//                 month: month,
//                 conversations: apiData.totalConversations,
//                 costPerConversation: apiData.totalCost / apiData.totalConversations, // Average cost per conversation
//                 totalCost: apiData.totalCost,
//                 dailyData: dailyData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             // Fallback to empty data on error
//             setBillingData({
//                 month: month,
//                 conversations: 0,
//                 costPerConversation: 0,
//                 totalCost: 0,
//                 dailyData: [],
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth); // Default to May 2025
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for DownloadButton
//     const downloadData = billingData ? [{
//         'Month': billingData.month,
//         'Total Conversations': billingData.conversations,
//         'Cost per Conversation (₹)': billingData.costPerConversation,
//         'Total Cost (₹)': billingData.totalCost,
//     }] : [];

//     // Chart data for daily billing trends (combo bar and line)
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [], // Extract day (e.g., "01", "02")
//         datasets: [
//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5', // Soft Pink
//                 backgroundColor: '#c99bb5',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (₹)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC', // Soft Indigo
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (₹)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations' },
//                 grid: { display: false },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 ₹{billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1">
//                         <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month}`}
//                         />
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import DownloadButton from '../components/downloadButton';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
//                 month: month,
//             }, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const apiData = response.data;
//             const dailyData = apiData.data.map(item => ({
//                 date: item.date,
//                 conversations: item.total_conversations,
//                 totalCost: item.cost,
//             }));

//             setBillingData({
//                 month: month,
//                 conversations: apiData.totalConversations,
//                 totalCost: apiData.totalCost,
//                 dailyData: dailyData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             setBillingData({
//                 month: month,
//                 conversations: 0,
//                 totalCost: 0,
//                 dailyData: [],
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth);
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for CSV download
//     const downloadData = billingData ? [
//         ...billingData.dailyData.map(item => ({
//             'Date': item.date,
//             'Conversations': item.conversations,
//             'Total Cost (INR)': item.totalCost,
//         })),
//         {
//             'Date': 'Total',
//             'Conversations': billingData.conversations,
//             'Total Cost (INR)': billingData.totalCost,
//         },
//     ] : [];

//     // Function to generate PDF
//     const generatePDF = () => {
//         const doc = new jsPDF();

//         // Header
//         doc.setFontSize(18);
//         doc.setTextColor(40);
//         doc.text('Billing Summary', 14, 22);

//         // Subtitle
//         doc.setFontSize(12);
//         doc.setTextColor(100);
//         doc.text(`Month: ${billingData?.month || 'N/A'}`, 14, 32);

//         // Table
//         autoTable(doc, {
//             startY: 40,
//             head: [['Date', 'Conversations', 'Total Cost (INR)']],
//             body: [
//                 ...billingData.dailyData.map(item => [
//                     item.date,
//                     item.conversations,
//                     item.totalCost,
//                 ]),
//                 [
//                     'Total',
//                     billingData.conversations,
//                     billingData.totalCost,
//                 ],
//             ],
//             theme: 'striped',
//             headStyles: {
//                 fillColor: [66, 103, 178],
//                 textColor: 255,
//                 fontSize: 10,
//             },
//             bodyStyles: {
//                 fontSize: 9,
//             },
//             alternateRowStyles: {
//                 fillColor: [240, 240, 240],
//             },
//             margin: { top: 40 },
//         });

//         // Footer
//         const pageCount = doc.internal.getNumberOfPages();
//         for (let i = 1; i <= pageCount; i++) {
//             doc.setPage(i);
//             doc.setFontSize(8);
//             doc.setTextColor(150);
//             doc.text(
//                 `Page ${i} of ${pageCount} | Generated on ${new Date().toLocaleDateString()}`,
//                 14,
//                 doc.internal.pageSize.height - 10
//             );
//         }

//         doc.save(`billing_${billingData?.month}.pdf`);
//     };

//     // Chart data for daily billing trends
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [],
//         datasets: [
//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5',
//                 backgroundColor: '#c99bb5',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (INR)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC',
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (INR)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations' },
//                 grid: { display: false },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 INR {billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1 flex gap-4 flex justify-end">
//                         {/* <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month}`}
//                         /> */}
//                         <button
//                             onClick={generatePDF}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={!billingData}
//                         >
//                             Download PDF
//                         </button>
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import DownloadButton from '../components/downloadButton';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// // Helper function to convert number to words
// const numberToWords = (num) => {
//     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//     const thousands = ['', 'Thousand', 'Million', 'Billion'];

//     if (num === 0) return 'Zero';

//     const convertLessThanThousand = (n) => {
//         if (n === 0) return '';
//         if (n < 10) return units[n];
//         if (n < 20) return teens[n - 10];
//         if (n < 100) return `${tens[Math.floor(n / 10)]}${n % 10 ? ' ' + units[n % 10] : ''}`;
//         return `${units[Math.floor(n / 100)]} Hundred${n % 100 ? ' ' + convertLessThanThousand(n % 100) : ''}`;
//     };

//     let parts = [];
//     let i = 0;
//     while (num > 0) {
//         const chunk = num % 1000;
//         if (chunk) {
//             parts.unshift(`${convertLessThanThousand(chunk)} ${thousands[i]}`.trim());
//         }
//         num = Math.floor(num / 1000);
//         i++;
//     }

//     return parts.join(', ');
// };

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             const response = await axios.post('https://vibe.fixall.ai/apis/billingData', {
//                 month: month,
//             }, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const apiData = response.data;
//             const dailyData = apiData.data.map(item => ({
//                 date: item.date,
//                 conversations: item.total_conversations,
//                 totalCost: item.cost,
//             }));

//             setBillingData({
//                 month: month,
//                 conversations: apiData.totalConversations,
//                 totalCost: apiData.totalCost,
//                 dailyData: dailyData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             setBillingData({
//                 month: month,
//                 conversations: 0,
//                 totalCost: 0,
//                 dailyData: [],
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth);
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for CSV download
//     const downloadData = billingData ? [
//         ...billingData.dailyData.map(item => ({
//             'Date': item.date,
//             'Conversations': item.conversations,
//             'Total Cost (INR)': item.totalCost,
//         })),
//         {
//             'Date': 'Total',
//             'Conversations': billingData.conversations,
//             'Total Cost (INR)': billingData.totalCost,
//         },
//     ] : [];

//     // Function to generate PDF
//     const generatePDF = () => {
//         const doc = new jsPDF();

//         // Header: TAX INVOICE
//         doc.setFontSize(22);
//         doc.setFont('helvetica', 'bold');
//         doc.text('TAX INVOICE', 105, 15, { align: 'center' });

//         // Original for Recipient
//         doc.setFontSize(10);
//         doc.setFont('helvetica', 'normal');
//         doc.text('ORIGINAL FOR RECIPIENT', 190, 10, { align: 'right' });

//         // Company and Invoice Details
//         autoTable(doc, {
//             startY: 20,
//             body: [
//                 [
//                     'Vibe Technologies Pvt. Ltd.\nGSTIN: 36AACCV1234Z1XW\n123 Tech Park, Gachibowli,\nHyderabad, Telangana, 500032\nMobile: 9876543210\nEmail: billing@vibetech.in',
//                     `Invoice #: INV-2025-001\nInvoice Date: 14 May 2025\nPlace of Supply: 36-TELANGANA\nDue Date: 14 May 2025`,
//                 ],
//             ],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             columnStyles: {
//                 0: { cellWidth: 90 },
//                 1: { cellWidth: 90, halign: 'right' },
//             },
//             didDrawCell: (data) => {
//                 if (data.section === 'body' && data.row.index === 0) {
//                     doc.setFont('helvetica', 'bold');
//                     doc.text('Vibe Technologies Pvt. Ltd.', data.cell.x + 2, data.cell.y + 5);
//                 }
//             },
//         });

//         // Customer Details
//         autoTable(doc, {
//             startY: doc.lastAutoTable.finalY + 10,
//             head: [['Customer Details:']],
//             body: [[
//                 'Natarajan Chandrasekaran\nBilling address:\n456 Business Avenue, Financial District,\nGachibowli, Hyderabad, Telangana, 500032\nPh: 9999999999'
//             ]],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             columnStyles: {
//                 0: { cellWidth: 180 },
//             },
//             didDrawCell: (data) => {
//                 if (data.section === 'head') {
//                     doc.setFont('helvetica', 'bold');
//                 }
//             },
//         });

//         // Billing Table (Removed Rate Column)
//         const taxableAmount = billingData.totalCost; // Before tax
//         const igstRate = 0.18;
//         const igstAmount = taxableAmount * igstRate;
//         const totalWithTax = taxableAmount + igstAmount;

//         autoTable(doc, {
//             startY: doc.lastAutoTable.finalY + 10,
//             head: [['S.No', 'Description', 'Conversations', 'Total Cost INR']],
//             body: [
//                 ...billingData.dailyData.map((item, index) => [
//                     index + 1,
//                     item.date,
//                     item.conversations,
//                     item.totalCost.toFixed(2),
//                 ]),
//                 [
//                     { content: `Total Items / Conversations: ${billingData.dailyData.length} / ${billingData.conversations}`, colSpan: 2, styles: { halign: 'right' } },
//                     'Taxable Amount',
//                     taxableAmount.toFixed(2),
//                 ],
//                 ['', '', 'IGST 18.0%', igstAmount.toFixed(2)],
//                 ['', '', 'Total', totalWithTax.toFixed(2)],
//             ],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             headStyles: {
//                 fillColor: [200, 200, 200],
//                 textColor: [0, 0, 0],
//                 fontStyle: 'bold',
//             },
//             columnStyles: {
//                 0: { cellWidth: 20, halign: 'center' },
//                 1: { cellWidth: 60 },
//                 2: { cellWidth: 50, halign: 'right' },
//                 3: { cellWidth: 50, halign: 'right' },
//             },
//         });

//         // Total Amount in Words
//         const [integerPart, decimalPart] = totalWithTax.toFixed(2).split('.');
//         const amountInWords = `INR ${numberToWords(parseInt(integerPart))} Rupees and ${numberToWords(parseInt(decimalPart))} Paise Only`;
//         doc.setFontSize(10);
//         doc.setFont('helvetica', 'italic');
//         const textWidth = doc.getTextWidth(amountInWords);
//         const pageWidth = doc.internal.pageSize.getWidth();
//         const xPosition = (pageWidth - textWidth) / 2; // Center the text
//         doc.text(`Total amount (in words): ${amountInWords}`, xPosition, doc.lastAutoTable.finalY + 15);

//         // Tax Breakdown Table
//         autoTable(doc, {
//             startY: doc.lastAutoTable.finalY + 25,
//             head: [['HSN/SAC', 'Taxable Value', 'Rate', 'Integrated Tax', 'Total Tax Amount']],
//             body: [
//                 ['998314', taxableAmount.toFixed(2), '18%', igstAmount.toFixed(2), igstAmount.toFixed(2)],
//                 ['', { content: 'TOTAL', colSpan: 3, styles: { halign: 'right' } }, igstAmount.toFixed(2), 'Amount Paid'],
//             ],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             headStyles: {
//                 fillColor: [200, 200, 200],
//                 textColor: [0, 0, 0],
//                 fontStyle: 'bold',
//             },
//             columnStyles: {
//                 0: { cellWidth: 30 },
//                 1: { cellWidth: 40, halign: 'right' },
//                 2: { cellWidth: 30, halign: 'right' },
//                 3: { cellWidth: 40, halign: 'right' },
//                 4: { cellWidth: 40, halign: 'right' },
//             },
//         });

//         // Bank Details (Removed Authorized Signatory)
//         autoTable(doc, {
//             startY: doc.lastAutoTable.finalY + 15,
//             body: [
//                 [
//                     'Bank Details:\nBank: YES BANK\nAccount #: 6678999222445\nIFSC: YESBIN4567\nBranch: Gachibowli',
//                     '',
//                 ],
//             ],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             columnStyles: {
//                 0: { cellWidth: 90 },
//                 1: { cellWidth: 90 },
//             },
//             didDrawCell: (data) => {
//                 if (data.section === 'body' && data.column.index === 0) {
//                     doc.setFont('helvetica', 'bold');
//                     doc.text('Bank Details:', data.cell.x + 2, data.cell.y + 5);
//                 }
//             },
//         });

//         // Notes and Terms
//         autoTable(doc, {
//             startY: doc.lastAutoTable.finalY + 15,
//             body: [
//                 [
//                     'Notes:\nThank you for the Business',
//                     'Terms and Conditions:\n1. Services once billed cannot be refunded or exchanged.\n2. We are not the service provider, company will stand for warranty as per their terms and conditions.\n3. Interest @24% p.a. will be charged for uncleared bills beyond 15 days.\n4. Subject to local Jurisdiction.',
//                 ],
//             ],
//             theme: 'plain',
//             styles: {
//                 fontSize: 10,
//                 cellPadding: 2,
//                 lineWidth: 0.5,
//                 lineColor: [0, 0, 0],
//             },
//             columnStyles: {
//                 0: { cellWidth: 90 },
//                 1: { cellWidth: 90 },
//             },
//             didDrawCell: (data) => {
//                 if (data.section === 'body' && data.column.index === 0) {
//                     doc.setFont('helvetica', 'bold');
//                     doc.text('Notes:', data.cell.x + 2, data.cell.y + 5);
//                 }
//                 if (data.section === 'body' && data.column.index === 1) {
//                     doc.setFont('helvetica', 'bold');
//                     doc.text('Terms and Conditions:', data.cell.x + 2, data.cell.y + 5);
//                 }
//             },
//         });

//         // Footer
//         const pageCount = doc.internal.getNumberOfPages();
//         for (let i = 1; i <= pageCount; i++) {
//             doc.setPage(i);
//             doc.setFontSize(8);
//             doc.setTextColor(150);
//             doc.text(
//                 `Page ${i} / ${pageCount}    This is a digitally signed document.`,
//                 14,
//                 doc.internal.pageSize.height - 10
//             );
//         }

//         doc.save(`billing_${billingData?.month}.pdf`);
//     };

//     // Chart data for daily billing trends
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [],
//         datasets: [
//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5',
//                 backgroundColor: '#c99bb5',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (INR)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC',
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (INR)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations' },
//                 grid: { display: false },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 INR {billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1 flex gap-4 justify-end">
//                         <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month}`}
//                         />
//                         <button
//                             onClick={generatePDF}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={!billingData}
//                         >
//                             Download PDF
//                         </button>
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import DownloadButton from '../components/downloadButton';
// import BillingPdf from '../components/billingPdf';
// import { apiurl } from '../config/config';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// function Billing() {
//     const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             const response = await axios.post(`${apiurl}/apis/billingData`, {
//                 month: month,
//             }, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const apiData = response.data;
//             const dailyData = apiData.data.map(item => ({
//                 date: item.date,
//                 conversations: item.total_conversations,
//                 totalCost: item.cost,
//             }));

//             setBillingData({
//                 month: month,
//                 conversations: apiData.totalConversations,
//                 totalCost: apiData.totalCost,
//                 invoiceNumber: apiData.invoiceNumber,
//                 totalGst: apiData.totalGst,
//                 totalCostWithGst: apiData.totalCostWithGst,
//                 totalCostWithGstInWords: apiData.totalCostWithGstInWords,
//                 dailyData: dailyData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             setBillingData({
//                 month: month,
//                 conversations: 0,
//                 totalCost: 0,
//                 dailyData: [],
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth);
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for CSV download
//     const downloadData = billingData ? [
//         ...billingData.dailyData.map(item => ({
//             'Date': item.date,
//             'Conversations': item.conversations,
//             'Total Cost (INR)': item.totalCost,
//         })),
//         {
//             'Date': 'Total',
//             'Conversations': billingData.conversations,
//             'Total Cost (INR)': billingData.totalCost,
//         },
//     ] : [];

//     // Chart data for daily billing trends
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [],
//         datasets: [
//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5',
//                 backgroundColor: '#c99bb5',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (INR)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC',
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (INR)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations' },
//                 grid: { display: false },
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 INR {billingData?.totalCost.toFixed(2) || '0.00'}
//                             </p>
//                             <p className="text-sm">
//                                 For {billingData?.conversations || 0} conversations
//                             </p>
//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1 flex gap-4 justify-end">
//                         <BillingPdf
//                             billingData={billingData}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={!billingData}
//                         />
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;

// import React, { useState, useEffect } from 'react';
// import Layout from '../components/layout';
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,
//     PointElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import axios from 'axios';
// import DownloadButton from '../components/downloadButton';
// import BillingPdf from '../components/billingPdf';
// import { apiurl } from '../config/config';

// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

// function Billing() {
//     // const [selectedMonth, setSelectedMonth] = useState('2025-05');
//     const [selectedMonth, setSelectedMonth] = useState(() => {
//         const now = new Date();
//         const month = String(now.getMonth() + 1).padStart(2, '0');
//         const year = now.getFullYear();
//         return `${year}-${month}`;
//     });
//     const [billingData, setBillingData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fetchBillingData = async (month) => {
//         setLoading(true);
//         try {
//             const response = await axios.post(`${apiurl}/apis/billingData`, {
//                 month: month,
//             }, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const apiData = response.data;
//             const dailyData = apiData.data.map(item => ({
//                 date: item.date,
//                 conversations: item.total_conversations,
//                 escalated_to_human: item.escalated_to_human,
//                 thumbs_up: item.thumbs_up,
//                 totalCost: item.cost,
//             }));

//             setBillingData({
//                 month: month,
//                 conversations: apiData.total_conversations,
//                 totalCost: apiData?.deflection?.total,
//                 invoiceNumber: apiData.invoiceNumber,
//                 totalGst: apiData.totalGst,
//                 totalCostWithGst: apiData.totalCostWithGst,
//                 totalCostWithGstInWords: apiData.totalCostWithGstInWords,
//                 totalHumanAgentThumbsUp: apiData?.deflection?.quantity,
//                 dailyData: dailyData,
//             });
//         } catch (err) {
//             console.error('API error:', err);
//             setBillingData({
//                 month: month,
//                 conversations: 0,
//                 totalCost: 0,
//                 dailyData: [],
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBillingData(selectedMonth);
//     }, []);

//     const handleMonthChange = () => {
//         if (selectedMonth) {
//             fetchBillingData(selectedMonth);
//         }
//     };

//     // Data for CSV download
//     const downloadData = billingData ? [
//         ...billingData.dailyData.map(item => ({
//             'Date': item.date,
//             'Conversations': item.conversations,
//             'Escalated to Human': item.escalated_to_human,
//             'Thumbs Up': item.thumbs_up,
//             'Total Cost (INR)': item.totalCost,
//         })),
//         {
//             'Date': 'Total',
//             'Conversations': billingData.conversations,
//             'Escalated to Human': billingData.dailyData.reduce((sum, item) => sum + item.escalated_to_human, 0),
//             'Thumbs Up': billingData.dailyData.reduce((sum, item) => sum + item.thumbs_up, 0),
//             'Total Cost (INR)': billingData.totalCost,
//         },
//     ] : [];

//     // Chart data for daily billing trends
//     const billingChartData = {
//         labels: billingData?.dailyData.map(item => item.date.slice(8, 10)) || [],
//         datasets: [
//             {
//                 type: 'line',
//                 label: 'Conversations',
//                 data: billingData?.dailyData.map(item => item.conversations) || [],
//                 borderColor: '#c99bb5',
//                 backgroundColor: '#c99bb5',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'line',
//                 label: 'Escalated to Human',
//                 data: billingData?.dailyData.map(item => item.escalated_to_human) || [],
//                 borderColor: '#4CAF50',
//                 backgroundColor: '#4CAF50',
//                 fill: false,
//                 yAxisID: 'y-conversations',
//             },
//             {
//                 type: 'line',
//                 label: 'Thumbs Up',
//                 data: billingData?.dailyData.map(item => item.thumbs_up) || [],
//                 borderColor: '#FF9800',
//                 backgroundColor: '#FF9800',
//                 fill: false,
//                 yAxisID: 'y-thumbs',
//             },
//             {
//                 type: 'bar',
//                 label: 'Total Cost (INR)',
//                 data: billingData?.dailyData.map(item => item.totalCost) || [],
//                 backgroundColor: '#A5B4FC',
//                 yAxisID: 'y-cost',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             title: { display: true, text: `Daily Billing Trends for ${billingData?.month || 'N/A'}` },
//         },
//         scales: {
//             x: {
//                 title: { display: true, text: 'Day of Month' },
//             },
//             'y-cost': {
//                 type: 'linear',
//                 position: 'left',
//                 title: { display: true, text: 'Total Cost (INR)' },
//                 grid: { display: false },
//             },
//             'y-conversations': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Conversations / Escalations' },
//                 grid: { display: false },
//             },
//             'y-thumbs': {
//                 type: 'linear',
//                 position: 'right',
//                 title: { display: true, text: 'Thumbs Up' },
//                 grid: { display: false },
//                 max: Math.max(...(billingData?.dailyData.map(item => item.thumbs_up) || [10]), 10),
//             },
//         },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* Billing Summary Card */}
//                 <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//                     <div className="flex items-center justify-between">
//                         <div className='text-start'>
//                             <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//                             <p className="text-sm">For {billingData?.month || 'N/A'}</p>
//                         </div>
//                         <div className="text-right">
//                             <p className="text-2xl font-bold">
//                                 INR {billingData?.totalCost?.toFixed(2) || '0.00'}
//                             </p>
//                             {/* <p className="text-sm">
//                                 { For {billingData?.conversations || 0} conversations }
//                                 Total Human agent & Thumbs up {billingData?.totalHumanAgentThumbsUp || 0}
//                             </p> */}
//                             <p className="text-sm">
//                                 Total Human agent & Thumbs up <strong>{billingData?.totalHumanAgentThumbsUp || 0}</strong>
//                             </p>

//                         </div>
//                     </div>
//                     <div className="mt-6 flex items-center justify-start gap-4">
//                         <div>
//                             <input
//                                 type="month"
//                                 value={selectedMonth}
//                                 onChange={(e) => setSelectedMonth(e.target.value)}
//                                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//                             />
//                         </div>
//                         <button
//                             onClick={handleMonthChange}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={loading}
//                         >
//                             {loading ? 'Loading...' : 'Update'}
//                         </button>
//                     </div>
//                     <div className="mt-6 md:mt-1 flex gap-4 justify-end">
//                         <BillingPdf
//                             billingData={billingData}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={!billingData}
//                         />
//                     </div>
//                 </div>

//                 {/* Billing Trends Chart */}
//                 <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//                     <h2 className="text-xl font-semibold text-gray-800 mb-4">Daily Billing Trends</h2>
//                     <div className="h-80">
//                         <Bar data={billingChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Billing;





// import React, { useState, useEffect } from "react";
// import Layout from "../components/layout";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import axios from "axios";
// import DownloadButton from "../components/downloadButton";
// import BillingPdf from "../components/billingPdf";
// import { apiurl } from "../config/config";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function Billing() {
//   const [selectedMonth, setSelectedMonth] = useState(() => {
//     const now = new Date();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const year = now.getFullYear();
//     return `${year}-${month}`;
//   });
//   const [billingData, setBillingData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   console.log("billingData", billingData);

//   const fetchBillingData = async (month) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${apiurl}/apis/billingData`,
//         {
//           month: month,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const apiData = response.data;
//       const dailyData =
//         apiData?.data?.map((item) => ({
//           date: item?.date ?? "",
//           conversations: item?.total_conversations ?? 0,
//           escalated_to_human: item?.escalated_to_human ?? 0,
//           thumbs_up: item?.thumbs_up ?? 0,
//           totalCost: item?.cost ?? 0,
//         })) ?? [];

//       setBillingData({
//         month: month,
//         conversations: apiData?.deflection?.total_conversations ?? 0,
//         totalCost: apiData?.deflection?.total ?? 0,
//         totalGst:
//           (apiData?.deflection?.gst ?? 0) +
//           (apiData?.infra_and_maintenance?.gst ?? 0),
//         totalCostWithGst: apiData?.total_amount ?? 0,
//         totalCostWithGstInWords: apiData?.total_amount_in_words ?? "",
//         invoiceNumber: apiData?.invoiceNumber ?? "N/A",
//         totalHumanAgentThumbsUp: apiData?.deflection?.quantity ?? 0,
//         dailyData: dailyData,
//         // Data to pass to BillingPdf
//         pdfData: {
//           invoiceNumber: apiData?.invoiceNumber ?? "N/A",
//           deflection: {
//             quantity: apiData?.deflection?.quantity ?? 0,
//             total_conversations: apiData?.deflection?.total_conversations ?? 0,
//             total: apiData?.deflection?.total ?? 0,
//             rate: apiData?.deflection?.rate ?? 0,
//             gst: apiData?.deflection?.gst ?? 0,
//             total_with_gst: apiData?.deflection?.total_with_gst ?? 0,
//             total_in_words: apiData?.deflection?.total_in_words ?? "",
//           },
//           infra_and_maintenance: {
//             quantity: apiData?.infra_and_maintenance?.quantity ?? 0,
//             total: apiData?.infra_and_maintenance?.total ?? 0,
//             rate: apiData?.infra_and_maintenance?.rate ?? 0,
//             gst: apiData?.infra_and_maintenance?.gst ?? 0,
//             total_with_gst: apiData?.infra_and_maintenance?.total_with_gst ?? 0,
//             total_in_words:
//               apiData?.infra_and_maintenance?.total_in_words ?? "",
//           },
//           total_amount: apiData?.total_amount ?? 0,
//           total_amount_in_words: apiData?.total_amount_in_words ?? "",
//         },
//       });
//     } catch (err) {
//       console.error("API error:", err);
//       setBillingData({
//         month: month,
//         conversations: 0,
//         totalCost: 0,
//         totalGst: 0,
//         totalCostWithGst: 0,
//         totalCostWithGstInWords: "",
//         invoiceNumber: "N/A",
//         totalHumanAgentThumbsUp: 0,
//         dailyData: [],
//         pdfData: {
//           invoiceNumber: "N/A",
//           deflection: {
//             quantity: 0,
//             total_conversations: 0,
//             total: 0,
//             rate: 0,
//             gst: 0,
//             total_with_gst: 0,
//             total_in_words: "",
//           },
//           infra_and_maintenance: {
//             quantity: 0,
//             total: 0,
//             rate: 0,
//             gst: 0,
//             total_with_gst: 0,
//             total_in_words: "",
//           },
//           total_amount: 0,
//           total_amount_in_words: "",
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBillingData(selectedMonth);
//   }, []);

//   const handleMonthChange = () => {
//     if (selectedMonth) {
//       fetchBillingData(selectedMonth);
//     }
//   };

//   // Data for CSV download
//   const downloadData = billingData
//     ? [
//         ...billingData.dailyData.map((item) => ({
//           Date: item.date,
//           Conversations: item.conversations,
//           "Escalated to Human": item.escalated_to_human,
//           "Thumbs Up": item.thumbs_up,
//           "Total Cost (INR)": item.totalCost.toFixed(2),
//         })),
//         {
//           Date: "Total",
//           Conversations: billingData.conversations,
//           "Escalated to Human": billingData.dailyData.reduce(
//             (sum, item) => sum + item.escalated_to_human,
//             0
//           ),
//           "Thumbs Up": billingData.dailyData.reduce(
//             (sum, item) => sum + item.thumbs_up,
//             0
//           ),
//           "Total Cost (INR)": billingData.totalCost.toFixed(2),
//         },
//       ]
//     : [];

//   // Chart data for daily billing trends
//   const billingChartData = {
//     labels: billingData?.dailyData?.map((item) => item.date.slice(8, 10)) ?? [],
//     datasets: [
//       {
//         type: "line",
//         label: "Conversations",
//         data: billingData?.dailyData?.map((item) => item.conversations) ?? [],
//         borderColor: "#c99bb5",
//         backgroundColor: "#c99bb5",
//         fill: false,
//         yAxisID: "y-conversations",
//       },
//       {
//         type: "line",
//         label: "Escalated to Human",
//         data:
//           billingData?.dailyData?.map((item) => item.escalated_to_human) ?? [],
//         borderColor: "#4CAF50",
//         backgroundColor: "#4CAF50",
//         fill: false,
//         yAxisID: "y-conversations",
//       },
//       {
//         type: "line",
//         label: "Thumbs Up",
//         data: billingData?.dailyData?.map((item) => item.thumbs_up) ?? [],
//         borderColor: "#FF9800",
//         backgroundColor: "#FF9800",
//         fill: false,
//         yAxisID: "y-thumbs",
//       },
//       {
//         type: "bar",
//         label: "Total Cost (INR)",
//         data: billingData?.dailyData?.map((item) => item.totalCost) ?? [],
//         backgroundColor: "#A5B4FC",
//         yAxisID: "y-cost",
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: "top" },
//       title: {
//         display: true,
//         text: `Daily Billing Trends for ${billingData?.month ?? "N/A"}`,
//       },
//     },
//     scales: {
//       x: {
//         title: { display: true, text: "Day of Month" },
//       },
//       "y-cost": {
//         type: "linear",
//         position: "left",
//         title: { display: true, text: "Total Cost (INR)" },
//         grid: { display: false },
//       },
//       "y-conversations": {
//         type: "linear",
//         position: "right",
//         title: { display: true, text: "Conversations / Escalations" },
//         grid: { display: false },
//       },
//       "y-thumbs": {
//         type: "linear",
//         position: "right",
//         title: { display: true, text: "Thumbs Up" },
//         grid: { display: false },
//         max: Math.max(
//           ...(billingData?.dailyData?.map((item) => item.thumbs_up) ?? [10]),
//           10
//         ),
//       },
//     },
//   };

//   return (
//     <Layout>
//       <div className="min-h-screen p-6">
//         {/* Billing Summary Card */}
//         <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
//           <div className="flex items-center justify-between">
//             <div className="text-start">
//               <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
//               <p className="text-sm">For {billingData?.month ?? "N/A"}</p>
//             </div>
//             <div className="text-right">
//               <p className="text-2xl font-bold">
//                 INR {billingData?.totalCost?.toFixed(2) ?? "0.00"}
//               </p>
//               <p className="text-sm">
//                 Total Human agent & Thumbs up{" "}
//                 <strong>{billingData?.totalHumanAgentThumbsUp ?? 0}</strong>
//               </p>
//             </div>
//           </div>
//           <div className="mt-6 flex items-center justify-start gap-4">
//             <div>
//               <input
//                 type="month"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//                 className="border rounded px-3 py-2 text-xs bg-transparent text-white"
//               />
//             </div>
//             <button
//               onClick={handleMonthChange}
//               className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//               disabled={loading}
//             >
//               {loading ? "Loading..." : "Update"}
//             </button>
//           </div>
//           <div className="mt-6 md:mt-1 flex gap-4 justify-end">
//             <BillingPdf
//               billingData={billingData?.pdfData}
//               className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//               disabled={!billingData}
//             />
//             {/* <DownloadButton
//                             data={downloadData}
//                             filename={`billing_${billingData?.month ?? 'data'}.csv`}
//                             className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
//                             disabled={!billingData}
//                         /> */}
//           </div>
//         </div>

//         {/* Billing Trends Chart */}
//         <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//           <h2 className="text-xl font-semibold text-gray-800 mb-4">
//             Daily Billing Trends
//           </h2>
//           <div className="h-80">
//             <Bar data={billingChartData} options={chartOptions} />
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// }

// export default Billing;






import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import axios from "axios";
// import DownloadButton from "../components/downloadButton";
// import BillingPdf from "../components/billingPdf";
import { apiurl } from "../config/config";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function Billing() {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${year}-${month}`;
  });
  const [billingData, setBillingData] = useState(null);
  const [loading, setLoading] = useState(false);

  console.log("billingData", billingData);

  const fetchBillingData = async (month) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${apiurl}/apis/billingData`,
        {
          month: month,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const apiData = response.data;
      const dailyData =
        apiData?.data?.map((item) => ({
          date: item?.date ?? "",
          conversations: item?.total_conversations ?? 0,
          escalated_to_human: item?.escalated_to_human ?? 0,
          thumbs_up: item?.thumbs_up ?? 0,
          totalCost: item?.cost ?? 0,
        })) ?? [];

        console.log("apiData", apiData);

      setBillingData({
        month: month,
        conversations: apiData?.deflection?.total_conversations ?? 0,
        totalCost: apiData?.totalCost ?? 0,
        totalGst:
          (apiData?.deflection?.gst ?? 0) +
          (apiData?.infra_and_maintenance?.gst ?? 0),
        totalCostWithGst: apiData?.total_amount ?? 0,
        totalCostWithGstInWords: apiData?.total_amount_in_words ?? "",
        invoiceNumber: apiData?.invoiceNumber ?? "N/A",
        totalHumanAgentThumbsUp: apiData?.total_humanAgent_thumbsUp?? 0,
        dailyData: dailyData,
        // Data to pass to BillingPdf
        pdfData: {
          invoiceNumber: apiData?.invoiceNumber ?? "N/A",
          deflection: {
            quantity: apiData?.deflection?.quantity ?? 0,
            total_conversations: apiData?.deflection?.total_conversations ?? 0,
            total: apiData?.deflection?.total ?? 0,
            rate: apiData?.deflection?.rate ?? 0,
            gst: apiData?.deflection?.gst ?? 0,
            total_with_gst: apiData?.deflection?.total_with_gst ?? 0,
            total_in_words: apiData?.deflection?.total_in_words ?? "",
          },
          infra_and_maintenance: {
            quantity: apiData?.infra_and_maintenance?.quantity ?? 0,
            total: apiData?.infra_and_maintenance?.total ?? 0,
            rate: apiData?.infra_and_maintenance?.rate ?? 0,
            gst: apiData?.infra_and_maintenance?.gst ?? 0,
            total_with_gst: apiData?.infra_and_maintenance?.total_with_gst ?? 0,
            total_in_words:
              apiData?.infra_and_maintenance?.total_in_words ?? "",
          },
          total_amount: apiData?.total_amount ?? 0,
          total_amount_in_words: apiData?.total_amount_in_words ?? "",
        },
      });
    } catch (err) {
      console.error("API error:", err);
      setBillingData({
        month: month,
        conversations: 0,
        totalCost: 0,
        totalGst: 0,
        totalCostWithGst: 0,
        totalCostWithGstInWords: "",
        invoiceNumber: "N/A",
        totalHumanAgentThumbsUp: 0,
        dailyData: [],
        pdfData: {
          invoiceNumber: "N/A",
          deflection: {
            quantity: 0,
            total_conversations: 0,
            total: 0,
            rate: 0,
            gst: 0,
            total_with_gst: 0,
            total_in_words: "",
          },
          infra_and_maintenance: {
            quantity: 0,
            total: 0,
            rate: 0,
            gst: 0,
            total_with_gst: 0,
            total_in_words: "",
          },
          total_amount: 0,
          total_amount_in_words: "",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillingData(selectedMonth);
  }, [selectedMonth]);

  const handleMonthChange = () => {
    if (selectedMonth) {
      fetchBillingData(selectedMonth);
    }
  };

  // Data for CSV download
  // const downloadData = billingData
  //   ? [
  //       ...billingData.dailyData.map((item) => ({
  //         Date: item.date,
  //         Conversations: item.conversations,
  //         "Escalated to Human": item.escalated_to_human,
  //         "Thumbs Up": item.thumbs_up,
  //         "Total Cost (INR)": item.totalCost.toFixed(2),
  //       })),
  //       {
  //         Date: "Total",
  //         Conversations: billingData.conversations,
  //         "Escalated to Human": billingData.dailyData.reduce(
  //           (sum, item) => sum + item.escalated_to_human,
  //           0
  //         ),
  //         "Thumbs Up": billingData.dailyData.reduce(
  //           (sum, item) => sum + item.thumbs_up,
  //           0
  //         ),
  //         "Total Cost (INR)": billingData.totalCost.toFixed(2),
  //       },
  //     ]
  //   : [];

  // Chart data for daily billing trends
  const billingChartData = {
    labels: billingData?.dailyData?.map((item) => item.date.slice(8, 10)) ?? [],
    datasets: [
      {
        type: "line",
        label: "Conversations",
        data: billingData?.dailyData?.map((item) => item.conversations) ?? [],
        borderColor: "#c99bb5",
        backgroundColor: "#c99bb5",
        fill: false,
        yAxisID: "y-conversations",
      },
      {
        type: "line",
        label: "Escalated to Human",
        data:
          billingData?.dailyData?.map((item) => item.escalated_to_human) ?? [],
        borderColor: "#4CAF50",
        backgroundColor: "#4CAF50",
        fill: false,
        yAxisID: "y-conversations",
      },
      {
        type: "line",
        label: "Thumbs Up",
        data: billingData?.dailyData?.map((item) => item.thumbs_up) ?? [],
        borderColor: "#FF9800",
        backgroundColor: "#FF9800",
        fill: false,
        yAxisID: "y-thumbs",
      },
      {
        type: "bar",
        label: "Total Cost (INR)",
        data: billingData?.dailyData?.map((item) => item.totalCost) ?? [],
        backgroundColor: "#A5B4FC",
        yAxisID: "y-cost",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: `Daily Billing Trends for ${billingData?.month ?? "N/A"}`,
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Day of Month" },
      },
      "y-cost": {
        type: "linear",
        position: "left",
        title: { display: true, text: "Total Cost (INR)" },
        grid: { display: false },
      },
      "y-conversations": {
        type: "linear",
        position: "right",
        title: { display: true, text: "Conversations / Escalations" },
        grid: { display: false },
      },
      "y-thumbs": {
        type: "linear",
        position: "right",
        title: { display: true, text: "Thumbs Up" },
        grid: { display: false },
        max: Math.max(
          ...(billingData?.dailyData?.map((item) => item.thumbs_up) ?? [10]),
          10
        ),
      },
    },
  };

  return (
    <Layout>
      <div className="min-h-screen p-6">
        {/* Billing Summary Card */}
        <div className="bg-gradient-to-r from-blue-400 to-indigo-500 p-8 rounded-xl shadow-lg mb-6 text-white">
          <div className="flex items-center justify-between">
            <div className="text-start">
              <h2 className="text-xl font-semibold mb-1">Billing Summary</h2>
              <p className="text-sm">For {billingData?.month ?? "N/A"}</p>
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold">
                INR {billingData?.totalCost?.toFixed(2) ?? "0.00"}
              </p>
              <p className="text-sm">
                Total Human agent & Thumbs up{" "}
                <strong>{billingData?.totalHumanAgentThumbsUp ?? 0}</strong>
              </p>
            </div>
          </div>
          <div className="mt-6 flex items-center justify-start gap-4">
            <div>
              <input
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="border rounded px-3 py-2 text-xs bg-transparent text-white"
              />
            </div>
            <button
              onClick={handleMonthChange}
              className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
              disabled={loading}
            >
              {loading ? "Loading..." : "Update"}
            </button>
          </div>
          {/* <div className="mt-6 md:mt-1 flex gap-4 justify-end">
            <BillingPdf
              billingData={billingData?.pdfData}
              className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
              disabled={!billingData}
            />
            <DownloadButton
                            data={downloadData}
                            filename={`billing_${billingData?.month ?? 'data'}.csv`}
                            className="hover:bg-indigo-400 text-white px-4 py-2 text-xs rounded border border-white"
                            disabled={!billingData}
                        /> 
          </div> */}
        </div>

        {/* Billing Trends Chart */}
        <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Daily Billing Trends
          </h2>
          <div className="h-80">
            <Bar data={billingChartData} options={chartOptions} />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Billing;
